module.exports = __webpack_public_path__ + "img/emailEle.57e13b4c.svg";